import { takeEvery, select, fork, put } from "redux-saga/effects";
import { request } from "util/api/client";
import { confirm, success, error } from "util/saga/feedback";
import { notify, pending } from "state/actions/ui";
import { resetTypes } from "state/actions/data";
import { storeOne } from "state/actions/data";

function* handleClear({ payload, context }) {
    try {
        if (yield confirm("Czy na pewno usunąć wszystkie wiadomość?")) {
            const response = yield request({
                url: `cms/form-responses/clear`,
                method: "post",
                context,
            });
            yield put(resetTypes(["cms.form-responses"], true));
        }
    } catch (e) {}
}

function* handleSend({ payload, context }) {
    const { id } = payload;
    try {
        if (yield confirm("Czy na pewno wysłać wiadomość?")) {
            yield put(pending(id, true));
            const response = yield request({
                url: `cms/form-responses/:id/send`,
                method: "post",
                data: { id },
                context,
            });
            const item = response.data.data;
            if (item && item.id) {
                yield put(storeOne("cms.form-responses", item.id, item));
            }
            yield put(pending(id, false));
            yield put(notify("Wysłano", "success"));
        }
    } catch (e) {
        yield put(pending(id, false));
        yield put(notify("Błąd wysyłki", "error"));
    }
}

export default function* () {
    yield takeEvery("CMS.FORMS.CLEAR", handleClear);
    yield takeEvery("CMS.FORMS.SEND", handleSend);
}
